import { initMediaGallery, destroyMediaGallery } from "./media-gallery";

/**
 * Visual effects + enhancements (3rd-party driven).
 *
 * Put here:
 * - ScrollReveal / Lozad / Fancybox initialization glue
 * - Feature-detection before calling globals
 *
 * Avoid here:
 * - Creating/owning the libraries themselves (loaded elsewhere)
 */


import {
	initAnimations,

} from "./animations";

export function initEffects() {
	// ScrollReveal
	// ScrollReveal
	if (typeof ScrollReveal !== "undefined") {
		const sr = ScrollReveal({
			duration: 1000,
			distance: "20px",
			easing: "cubic-bezier(0.5, 0, 0, 1)",
			once: true,
		});

		// Fade Up
		sr.reveal(".fd-up", {
			origin: "bottom",
			delay: 200,
		});

		// Fade Down
		sr.reveal(".fd-down", {
			origin: "top",
			delay: 200,
		});

		// Fade Left
		sr.reveal(".fd-left", {
			origin: "right",
			delay: 200,
		});

		// Fade Right
		sr.reveal(".fd-right", {
			origin: "left",
			delay: 200,
		});

		// Fade In (zoom)
		sr.reveal(".fd-in", {
			scale: 0.9,
			opacity: 0,
			delay: 200,
			distance: "0px",
		});

		// Optional stagger for children
		sr.reveal(".stagger > *", {
			origin: "bottom",
			interval: 120,
		});
	}

	// Lozad (lazy load) — single site-wide observer.
	// window.lozadObserver is the only instance (libs.js / work.js must reuse it).
	// Gallery main images use this same loader via triggerLoad on slide changes.
	// rootMargin 200px preloads before scroll enter; Swiper triggerLoad covers peeks.
	if (typeof lozad !== "undefined") {
		window.lozadObserver = lozad(".lozad:not(.media-gallery-image)", {
			rootMargin: "200px 200px",
			threshold: 0.01
		});
		window.lozadObserver.observe();
	}

	// Fancybox
	if (typeof Fancybox !== "undefined") {
		Fancybox.bind("[data-fancybox]", {
			on: {
				closing: (fancybox) => destroyMediaGallery(fancybox.getSlide()?.$content),
				reveal: (fancybox, slide) => {
					if (!slide?.$content) return;
					requestAnimationFrame(() => {
						// Galleries manage their own image loading and slider updates.
						if (initMediaGallery(slide.$content)) return;
						slide.$content.querySelectorAll(".swiper").forEach((el) => {
							const swiper = el.swiper || window.initSwiper?.find((s) => s.el === el);
							swiper?.update();
						});
						slide.$content
							.querySelectorAll("img.lozad, .lozad, img[data-src]")
							.forEach((img) => {
								window.lozadObserver?.triggerLoad?.(img);
								if (img.dataset.src && !img.src) {
									img.src = img.dataset.src;
									img.setAttribute("data-loaded", "true");
								}
							});
					});
				},
			},
		});
	}



	if ($(".news-detail").length) {

		// Find all iframes inside .news-detail
		$(".news-detail iframe").each(function () {
			const $iframe = $(this);

			// Skip if iframe is inside .pdf-iframe
			if ($iframe.closest(".pdf-iframe").length === 0) {

				// Prevent double wrapping
				if (!$iframe.parent().hasClass("iframe-ratio")) {
					$iframe.wrap("<div class='iframe-ratio'></div>");
				}
			}
		});
	}

	wrapTextWords(".text-fd-up");
	wrapTextWords(".text-slide-up");
	initTextSlideUpObserver();
	// ── Generic page-wide animations (use default selectors) ────────────────
	initAnimations();
}

function wrapTextWords(selector) {
	document.querySelectorAll(selector).forEach((el) => {
		if (el.dataset.wordsWrapped) return;

		let newHTML = "";
		let wordIndex = 0;

		Array.from(el.childNodes).forEach((node) => {
			if (node.nodeType === Node.TEXT_NODE) {
				const words = node.nodeValue.split(/\s+/).filter((w) => w.trim() !== "");

				newHTML += words
					.map((word) => {
						const span = `<span class="word" style="--i:${wordIndex}">${word}&nbsp;</span>`;
						wordIndex++;
						return span;
					})
					.join("");
			} else if (node.nodeName.toLowerCase() === "br") {
				newHTML += "<br>";
			} else {
				newHTML += node.outerHTML || "";
			}
		});

		el.innerHTML = newHTML;
		el.dataset.wordsWrapped = "true";
	});
}

function initTextSlideUpObserver() {
	const elements = document.querySelectorAll(".text-slide-up");
	if (!elements.length) return;

	const reveal = (el) => {
		el.classList.remove("is-visible");
		void el.offsetWidth;
		el.classList.add("is-visible");
	};

	const hide = (el) => {
		el.classList.remove("is-visible");
	};

	if (!("IntersectionObserver" in window)) {
		elements.forEach(reveal);
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					reveal(entry.target);
				} else {
					hide(entry.target);
				}
			});
		},
		{ rootMargin: "0px 0px -10% 0px", threshold: 0.15 }
	);

	elements.forEach((el) => observer.observe(el));
}